var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationOnOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49999 0.833328C3.88749 0.833328 2.58333 2.13749 2.58333 3.74999C2.58333 5.48749 4.42499 7.88333 5.18333 8.79583C5.35 8.99583 5.65416 8.99583 5.82083 8.79583C6.575 7.88333 8.41666 5.48749 8.41666 3.74999C8.41666 2.13749 7.11249 0.833328 5.49999 0.833328ZM5.49999 4.79166C4.92499 4.79166 4.45833 4.32499 4.45833 3.74999C4.45833 3.17499 4.92499 2.70833 5.49999 2.70833C6.075 2.70833 6.54166 3.17499 6.54166 3.74999C6.54166 4.32499 6.075 4.79166 5.49999 4.79166Z",
    fill: "#EA6A47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOnOrange);
export default __webpack_public_path__ + "static/media/Location_on_orange.6dfcdc6de504d9adaa014b3aecb43612.svg";
export { ForwardRef as ReactComponent };